import styles from './Rodape.module.css'
import { AiOutlineLinkedin, AiFillGithub, AiOutlineInstagram } from "react-icons/ai"

export default function Rodape() {
    return (
        <footer className={styles.rodape}>
            <p>Site desenvolvido por Bruno Bahy</p>
            <div>
                <a href="https://www.instagram.com/brunobahy/">
                    <AiOutlineInstagram size={50} color="#B6EADA" />

                </a>
                <a href="https://www.linkedin.com/in/bruno-bahy">
                    <AiOutlineLinkedin size={50} color="#B6EADA" />

                </a>
                <a href="https://github.com/Brunobahy">
                    <AiFillGithub size={50} color="#B6EADA" />

                </a>
            </div>
        </footer>
    )
}
